import { type FC } from "react";

import { type RemoteApiSpec } from "../../../../gql-generated/types";

import { EndpointDetails } from "./EndpointDetails";

interface EndpointsDetailsProps {
    spec: RemoteApiSpec;
}

export const EndpointsDetails: FC<EndpointsDetailsProps> = ({ spec: { endpoints, host } }) => {
    return (
        <>
            {endpoints.map((endpoint, index) => {
                return (
                    <EndpointDetails
                        title={`Endpoint ${index + 1} - ${endpoint.refId}`}
                        key={`endpoint-${index}`}
                        endpoint={endpoint}
                        host={host}
                    />
                );
            })}
        </>
    );
};
